module.exports = __webpack_public_path__ + "static/fig-04-5f67cd75634767af1736b13b4e8773b7.png";